import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { observer } from 'mobx-react'
import AuthenticationStore from '../stores/AuthenticationStore'

@observer
class RootComponent extends Component {
  static propTypes = {
    authenticationStore: PropTypes.instanceOf(AuthenticationStore).isRequired
  }

  render () {
    const { authenticationStore } = this.props
    if (!authenticationStore.isLoading) {
      if (authenticationStore.isLoggedIn) {
        if (authenticationStore.loggedUser.isClient) {
          return <Redirect to='/next-events' />
        } else {
          return <Redirect to='/calendars' />
        }
      } else {
        return <Redirect to='login' />
      }
    }

    return (
      <div />
    )
  }
}

export default RootComponent
